import React, { useContext } from 'react';

const Environmentjson = {
    name: "environment",
    widgetlist: [
        {
            //Donut
            widgetname: "Emission Evolution",
            type: "text_donut", //Donut with white semicircle
            props: {
                basic: {
                    height: "284px", //Height width properties
                    width: "4",
                    //styling properties
                    font_data: {
                        fontsize: "16px",
                        fonttype: "Roboto",
                        // fontstyle: "Bold",
                        color: "#1E8EFA",
                        color_dark: "#1E8EFA"
                    },
                    color_background: "#EDEFEE",
                    color_background_dark: "#030303",
                    border: {
                        borderradius: "8px",
                        // borderwidth: 0,
                        // bordercolor: "#FFFFFF",
                        // bordercolor_dark: "#000000",
                    },
                    icon: {  // information icon and expand icon
                        color: "#C2CBC8",
                        color_dark: "#C2CBC8"
                    }
                },
                extended: {
                    dataLabels_enabled: false,
                    fontsize: '15px',//font for x axis and y axis
                    fonttype: "Arial, Helvetica, sans-serif",
                    fontstyle: "normal",
                    fontweight: 400,
                    textname: {
                        color: "#FFFFFF",
                        fontfamily: "Roboto",
                        fontsize: "20px",
                        fontweight: 700,
                    },
                    textvalue: {
                        color: "#FFFFFF",
                        fontfamily: "Roboto",
                        fontsize: "20px",
                        fontweight: 700,
                    },
                    legend: {
                        enabled: true,
                        fontsize: '12px',
                        fontsize: 400,
                        markers_fillcolors: ['#5588FF', '#5ab931', '#66ff00'],
                        markers_radius: '12px',
                    },
                    tagprops: [
                        {
                            tagname: "Scope1",
                            chartprops: {
                                color: '#0076F6',
                                color_dark: '#0076F6'
                            },
                        },
                        {
                            tagname: "Scope2",
                            chartprops: {
                                color: '#EE8C19',
                                color_dark: '#EE8C19'
                            },
                        },
                        {
                            tagname: "Scope3",
                            chartprops: {
                                color: '#00943D',
                                color_dark: '#00943D'
                            },
                        },
                    ],
                },
            },
        },
        {
            //Donut
            widgetname: "Renewable vs Non-Renewable",
            type: "text_donut", //Donut with white semicircle
            props: {
                basic: {
                    height: "284px", //Height width properties
                    width: "4",
                    //styling properties
                    font_data: {
                        fontsize: "16px",
                        fonttype: "Roboto",
                        // fontstyle: "Bold",
                        color: "#1E8EFA",
                        color_dark: "#1E8EFA"
                    },
                    color_background: "#EDEFEE",
                    color_background_dark: "#030303",
                    border: {
                        borderradius: "8px",
                        // borderwidth: 0,
                        // bordercolor: "#FFFFFF",
                        // bordercolor_dark: "#000000",
                    },
                    icon: {  // information icon and expand icon
                        color: "#C2CBC8",
                        color_dark: "#C2CBC8"
                    }
                },
                extended: {
                    dataLabels_enabled: false,
                    fontsize: '15px',//font for x axis and y axis
                    fonttype: "Arial, Helvetica, sans-serif",
                    fontstyle: "normal",
                    fontweight: 400,
                    textname: {
                        color: "#FFFFFF",
                        fontfamily: "Roboto",
                        fontsize: "20px",
                        fontweight: 700,
                    },
                    textvalue: {
                        color: "#FFFFFF",
                        fontfamily: "Roboto",
                        fontsize: "20px",
                        fontweight: 700,
                    },
                    legend: {
                        enabled: true,
                        fontsize: '12px',
                        fontsize: 400,
                        markers_fillcolors: ['#5588FF', '#5ab931', '#66ff00'],
                        markers_radius: '12px',
                    },
                    tagprops: [
                        {
                            tagname: "Renewable",
                            chartprops: {
                                color: "#00943D",
                                color_dark: "#00943D"
                            },
                        },
                        {
                            tagname: "Non-Renewable",
                            chartprops: {
                                color: '#EE8C19',
                                color_dark: '#EE8C19'
                            },
                        },
                    ],
                },
            },
        },
        {
            //Donut
            widgetname: "AQI",
            type: "aqiguage", //Donut with white semicircle
            props: {
                basic: {
                    height: "284px", //Height width properties
                    width: "4",
                    //styling properties
                    font_data: {
                        fontsize: "16px",
                        fonttype: "Roboto",
                        // fontstyle: "Bold",
                        color: "#1E8EFA",
                        color_dark: "#1E8EFA"
                    },
                    color_background: "#EDEFEE",
                    color_background_dark: "#030303",
                    border: {
                        borderradius: "8px",
                        // borderwidth: 0,
                        // bordercolor: "#FFFFFF",
                        // bordercolor_dark: "#000000",
                    },
                    icon: {  // information icon and expand icon
                        color: "#C2CBC8",
                        color_dark: "#C2CBC8"
                    }
                },
                extended: {
                    dataLabels_enabled: false,
                    fontsize: '15px',//font for x axis and y axis
                    fonttype: "Arial, Helvetica, sans-serif",
                    fontstyle: "normal",
                    fontweight: 400,
                    textname: {
                        color: "#FFFFFF",
                        fontfamily: "Roboto",
                        fontsize: "20px",
                        fontweight: 700,
                    },
                    textvalue: {
                        color: "#FFFFFF",
                        fontfamily: "Roboto",
                        fontsize: "20px",
                        fontweight: 700,
                    },
                    legend: {
                        enabled: true,
                        fontsize: '12px',
                        fontsize: 400,
                        markers_fillcolors: ['#5588FF', '#5ab931', '#66ff00'],
                        markers_radius: '12px',
                    },
                    tagprops: [
                        {
                            tagname: "Good",
                            chartprops: {
                                color: '#00943D',
                                color_dark: '#00943D'
                            },
                        },
                        {
                            tagname: "Moderate",
                            chartprops: {
                                color: '#EE8C19',
                                color_dark: '#EE8C19'
                            },
                        },
                        {
                            tagname: "Unhealthy for Sensitive Groups",
                            chartprops: {
                                color: '#FFD000',
                                color_dark: '#FFD000'
                            },
                        },
                        {
                            tagname: "Unhealthy",
                            chartprops: {
                                color: '#DC272D',
                                color_dark: '#DC272D'
                            },
                        },//Hazarddous
                        {
                            tagname: "Very Unhealthy",
                            chartprops: {
                                color: '#A2A2A2',
                                color_dark: '#A2A2A2'
                            },
                        },
                        {
                            tagname: "Hazardous",
                            chartprops: {
                                color: '#5E0F12',
                                color_dark: '#5E0F12'
                            },
                        },
                    ],
                },
            },
        },
        {
            widgetname: "Carbon Emissions (tCO2e)",
            type: "line",
            props: {
                basic: {
                    height: "284px", //Height width properties
                    width: "6",
                    //styling properties
                    font_data: {
                        fontsize: "16px",
                        fonttype: "Roboto",
                        // fontstyle: "Bold",
                        color: "#1E8EFA",
                        color_dark: "#1E8EFA"
                    },
                    color_background: "#EDEFEE",
                    color_background_dark: "#030303",
                    border: {
                        borderradius: "8px",
                        // borderwidth: 0,
                        // bordercolor: "#FFFFFF",
                        // bordercolor_dark: "#000000",
                    },
                    icon: {  // information icon and expand icon
                        color: "#C2CBC8",
                        color_dark: "#C2CBC8"
                    }
                },
                extended: {
                    dataLabels_enabled: false,//This property is not used
                    fontsize: '8px',
                    fontfamily: 'Roboto',
                    fontweight: 700,
                    title: {
                        fontsize: '10px',
                        fontfamily: 'Roboto',
                        fontweight: 400,
                    },
                    legend: {
                        fontsize: '8px',
                        fontfamily: 'Roboto',
                        fontweight: 400,
                        marker: {
                            radius: 12,
                            height: "10px",
                            width: "10px",
                        }
                    },
                    tagprops: [
                        {
                            tagname: "Scope1",
                            chartprops: {
                                color: '#0076F6',
                                color_dark: '#0076F6'
                            },
                        },
                        {
                            tagname: "Scope2",
                            chartprops: {
                                color: '#EE8C19',
                                color_dark: '#EE8C19'
                            },
                        },
                        {
                            tagname: "Scope3",
                            chartprops: {
                                color: '#00943D',
                                color_dark: '#00943D'
                            },
                        },

                    ],
                },
            },
        },
        {
            widgetname: "Emissions Inventory",
            type: "emtable",
            props: {
                basic: {
                    height: "284px", //Height width properties
                    width: "6",
                    //styling properties
                    font_data: {
                        fontsize: "16px",
                        fonttype: "Roboto",
                        // fontstyle: "Bold",
                        color: "#1E8EFA",
                        color_dark: "#1E8EFA"
                    },
                    color_background: "#EDEFEE",
                    color_background_dark: "#030303",
                    border: {
                        borderradius: "8px",
                        // borderwidth: 0,
                        // bordercolor: "#FFFFFF",
                        // bordercolor_dark: "#000000",
                    },
                    icon: {  // information icon and expand icon
                        color: "#C2CBC8",
                        color_dark: "#C2CBC8"
                    }
                },
                extended: {
                    column_orientation: "vertical",
                    backgroundcolor: "EDEFEE",
                    tablehead: {
                        color: "#3A4452",
                        color_dark: "#3A4452",
                        fontsize: '12px',
                        fonttype: "Roboto",
                        fontweight: 700,
                    },
                    tablerows: {
                        color: "#3A4452",
                        color_dark: "#3A4452",
                        fontsize: '12px',
                        fonttype: "Roboto",
                        fontweight: 400,
                    },
                    legend: { //Provision for tables that have option for legends 
                        enabled: true,
                        fontsize: '12px',
                        markers_fillcolors: ['#5588FF', '#5ab931', '#66ff00'],
                        markers_radius: '12px',
                    },
                    tagprops: [ //remove chatype and props as its a table colors for column
                        {
                            tagname: "Baseline Target",

                        },
                        {
                            tagname: "Yearly Target",

                        },
                        {
                            tagname: "Yearly Consumption",

                        },
                        {
                            tagname: "This Month's Target",

                        },
                        {
                            tagname: "This Month's Deviation",
                            charttype: "",
                            chartprops: {

                            },
                        },
                        {
                            tagname: "Monthly Asking Rate",
                            charttype: "",
                            chartprops: {

                            },
                        },
                        {
                            tagname: "Today's Consumption",
                            charttype: "",
                            chartprops: {

                            },
                        },
                    ],
                },
            },
        },
        {
            //Mix
            widgetname: "Water Consumption",
            type: "mix",
            props: {
                basic: {
                    height: "284px", //Height width properties
                    width: "6",
                    //styling properties
                    font_data: {
                        fontsize: "16px",
                        fonttype: "Roboto",
                        // fontstyle: "Bold",
                        color: "#1E8EFA",
                        color_dark: "#1E8EFA"
                    },
                    color_background: "#EDEFEE",
                    color_background_dark: "#030303",
                    border: {
                        borderradius: "8px",
                        // borderwidth: 0,
                        // bordercolor: "#FFFFFF",
                        // bordercolor_dark: "#000000",
                    },
                    icon: {  // information icon and expand icon
                        color: "#C2CBC8",
                        color_dark: "#C2CBC8"
                    }
                },
                extended: {
                    dataLabels_enabled: false,//This property is not used
                    fontsize: '8px',
                    fontfamily: 'Roboto',
                    fontweight: 700,
                    title: {
                        fontsize: '10px',
                        fontfamily: 'Roboto',
                        fontweight: 400,
                    },
                    legend: {
                        fontsize: '8px',
                        fontfamily: 'Roboto',
                        fontweight: 400,
                        marker: {
                            radius: 12,
                            height: "10px",
                            width: "10px",
                        }
                    },
                    annotations: {  //Annotation properties are not used - check for single color
                        enabled: false,
                        radius: 2,
                        label_borderColor: "#000000",
                        label_color: "#fff",
                        label_background: "#000000",
                    },
                    tagprops: [
                        {
                            //Energy 
                            tagname: "Consumption",
                            charttype: "bar",
                            chartprops:
                            {
                                color: '#1E8EFA',
                                color_dark: '#1E8EFA',
                                width: 2,
                                curve: 'smooth',
                            },
                        },
                        {
                            //Energy 
                            tagname: "Target",
                            charttype: "marker",
                            chartprops: {
                                color: '#DC272D',
                                color_dark: '#DC272D',
                                width: 2,
                                curve: 'smooth',
                            },
                        },

                    ],
                },
            },
        },
        {
            //Bar
            widgetname: "Waste Generation",
            type: "bar",
            props: {
                basic: {
                    height: "284px", //Height width properties
                    width: "6",
                    //styling properties
                    font_data: {
                        fontsize: "16px",
                        fonttype: "Roboto",
                        // fontstyle: "Bold",
                        color: "#1E8EFA",
                        color_dark: "#1E8EFA"
                    },
                    color_background: "#EDEFEE",
                    color_background_dark: "#030303",
                    border: {
                        borderradius: "8px",
                        // borderwidth: 0,
                        // bordercolor: "#FFFFFF",
                        // bordercolor_dark: "#000000",
                    },
                    icon: {  // information icon and expand icon
                        color: "#C2CBC8",
                        color_dark: "#C2CBC8"
                    }
                },
                extended: {
                    dataLabels_enabled: false,//This property is not used
                    fontsize: '8px',
                    fontfamily: 'Roboto',
                    fontweight: 700,
                    stacked: false,
                    horizontal: false,
                    title: {
                        fontsize: '10px',
                        fontfamily: 'Roboto',
                        fontweight: 400,
                    },
                    legend: {
                        fontsize: '8px',
                        fontfamily: 'Roboto',
                        fontweight: 400,
                        marker: {
                            radius: 12,
                            height: "10px",
                            width: "10px",
                        }
                    },
                    tagprops: [
                        {
                            //Energy 
                            tagname: "Recyclable",
                            chartprops: {
                                color: '#00943D',
                                color_dark: '#00943D',
                            },
                        },
                        {
                            //CO2
                            tagname: "Non-Recyclable",
                            chartprops: {
                                color: '#EE8C19',
                                color_dark: '#EE8C19',
                            },
                        }
                    ],
                },
            },
        },
        {
            //Donut
            widgetname: "Air Pollutants",
            type: "bar", //Donut with white semicircle
            props: {
                basic: {
                    height: "284px", //Height width properties
                    width: "12",
                    //styling properties
                    font_data: {
                        fontsize: "16px",
                        fonttype: "Roboto",
                        // fontstyle: "Bold",
                        color: "#1E8EFA",
                        color_dark: "#1E8EFA"
                    },
                    color_background: "#EDEFEE",
                    color_background_dark: "#030303",
                    border: {
                        borderradius: "8px",
                        // borderwidth: 0,
                        // bordercolor: "#FFFFFF",
                        // bordercolor_dark: "#000000",
                    },
                    icon: {  // information icon and expand icon
                        color: "#C2CBC8",
                        color_dark: "#C2CBC8"
                    }
                },
                extended: {
                    dataLabels_enabled: true,//This property is not used
                    fontsize: '8px',
                    fontfamily: 'Roboto',
                    fontweight: 700,
                    stacked: true,
                    horizontal: false,
                    title: {
                        fontsize: '10px',
                        fontfamily: 'Roboto',
                        fontweight: 400,
                    },
                    legend: {
                        fontsize: '8px',
                        fontfamily: 'Roboto',
                        fontweight: 400,
                        marker: {
                            radius: 12,
                            height: "10px",
                            width: "10px",
                        }
                    },
                    tagprops: [
                        {
                            //Energy 
                            tagname: "CO",
                            chartprops:
                            {
                                color: '#033176',
                                color_dark: '#033176',
                            },
                        },
                        {
                            //CO2
                            tagname: "NO\u2082",
                            chartprops:
                            {
                                color: '#0549B1',
                                color_dark: '#0549B1',
                            },
                        },
                        {
                            //CO2
                            tagname: "SO\u2082",
                            chartprops:
                            {
                                color: '#0766F6',
                                color_dark: '#0766F6',
                            },
                        },
                        {
                            //CO2
                            tagname: "O\u2083",
                            chartprops:
                            {
                                color: '#4C90F8',
                                color_dark: '#4C90F8',
                            },
                        },
                        {
                            //CO2
                            tagname: "PM\u2081\u2080",
                            chartprops:
                            {
                                color: '#88B6FB',
                                color_dark: '#88B6FB',
                            },
                        },
                        {
                            //CO2
                            tagname: "PM\u2082\u002E\u2085",
                            chartprops:
                            {
                                color: '#88B6FC',
                                color_dark: '#88B6FC',
                            },
                        }
                    ],

                },
            },
        },

    ]
};

export default Environmentjson;